import api from "./Api";



export const addSystemLog = async (recordUser, logCodeID, logRelatedID, logDetail) => {
    const response = await api.post(`/systemLog/addLog`, {
        recordUser: recordUser,
        logCodeID: logCodeID,
        logRelatedID: logRelatedID,
        logDetail: logDetail
    });
    return response.data;
};



